<template>
  <div class="fd">
    <fieldset class="fd-fieldset">
      <div class="fd-heading">Alıcı Detayları</div>
      <div class="fd-card">
        <div class="fd-row">
          <span class="fd-label">Alıcı Adı</span>
          <span class="fd-value">{{ data.TargetSystem.Name }}</span>
        </div>
        <div class="fd-row">
          <span class="fd-label">Türü</span>
          <span class="fd-value">{{ data.TargetSystem.Kind | finalizerKind }}</span>
        </div>
        <div class="fd-row" v-for="e in data.TargetSystem.ExtraFields" :key="e.Key">
          <span class="fd-label">{{ e.Key }}</span>
          <span class="fd-value">{{ e.Value }}</span>
        </div>
        <div class="fd-row">
          <span class="fd-label">Durum</span>
          <span class="fd-value">
            <finalizer-state-icon :state="data.State" :show-label="true" :voya="true" />
          </span>
        </div>
      </div>

      <div class="fd-card" v-show="data.Results && data.Results.length > 0">
        <div class="fd-section-title">İşlem Geçmişi</div>
        <div class="fd-history">
          <div v-for="r in finalizerResults" :key="r.Date" class="fd-result">
            <div class="fd-result-head">
              <finalizer-state-icon :state="r.State" :show-label="false" :voya="true" />
              <span v-show="r.Count > 1" title="Tekrar sayısı" class="fd-count">x{{ r.Count }}</span>
              <span class="fd-date">{{ r.Date | datetime }}</span>
            </div>
            <div class="fd-result-body">
              <div>{{ r.Description }}</div>
              <small v-if="r.ExceptionData" class="fd-muted">{{ r.ExceptionData.Message }}</small>
              <div v-if="r.User" class="fd-user">{{ r.User.FullName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="fd-bar">
        <div class="fd-bar-inner" role="group">
          <button type="button" class="fd-btn" @click="$emit('back')">
            Geri
          </button>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>

import finalizerStateIcon from '../components/FinalizerStateIcon.vue';
export default {
  components: {
    finalizerStateIcon
  },
  data() {
    return {
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    finalizerResults() {
      return [...this.data.Results].reverse(); //.reverse();
    }
  }
};
</script>

<style scoped>
/* Voya: alıcı detayı */
.fd {
  padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 96px);
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  color: #092154;
}

.fd-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.fd-heading {
  margin: 12px 4px 0 4px;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #092154;
}

.fd-card {
  box-sizing: border-box;
  margin-top: 12px;
  padding: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
}

.fd-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
}

.fd-row + .fd-row {
  border-top: 1px solid #EFEFEF;
}

.fd-label {
  flex-shrink: 0;
  font-weight: 400;
  font-size: 14px;
  color: #808080;
}

.fd-value {
  min-width: 0;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  word-break: break-word;
}

.fd-section-title {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #092154;
}

.fd-history {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.fd-result {
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid #DCE3F2;
  border-radius: 10px;
  background-color: #F1F7FF;
}

.fd-result-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fd-count {
  padding: 0 8px;
  border-radius: 100px;
  background-color: #FDECEE;
  font-weight: 500;
  font-size: 11px;
  line-height: 18px;
  color: #DC3545;
}

.fd-date {
  margin-left: auto;
  font-size: 12px;
  color: #808080;
}

.fd-result-body {
  margin-top: 6px;
  white-space: pre-wrap;
  overflow-x: auto;
  font-size: 13px;
  line-height: 150%;
  color: #333333;
}

.fd-muted {
  display: block;
  color: #808080;
}

.fd-user {
  margin-top: 2px;
  font-weight: 500;
  color: #092154;
}

.fd-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  padding: 12px 16px calc(env(safe-area-inset-bottom, 0px) + 12px) 16px;
  border-top: 1px solid #EFEFEF;
  background-color: #ffffff;
  box-shadow: 0 -4px 16px rgba(9, 33, 84, 0.08);
}

.fd-bar-inner {
  display: flex;
  max-width: 560px;
  margin: 0 auto;
}

.fd-btn {
  flex: 1 1 0;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #182F5E;
  border-radius: 8px;
  background-color: #ffffff;
  font-family: inherit;
  font-weight: 600;
  font-size: 15px;
  color: #182F5E;
}

.fd-btn:active {
  background-color: #F4F6FA;
}
</style>
